const hierarchy = [
  { value: "ItemArea", description: "ItemArea" },
  { value: "MacroArea", description: "MacroArea" },
  { value: "Region", description: "Region" },
];

export default hierarchy;
